import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { DocumentService } from '@app/shared/services';
import { Subscription } from 'rxjs';
import { AddDocumentComponent } from '../../add-document.component';
import { MatDialog } from '@angular/material/dialog';
import { CryptoService } from '@app/shared/services/crypto/crypto.services';
import { SharedDocViewerDialogComponent } from '@app/shared/component/shared-doc-viewer-dialog/shared-doc-viewer-dialog.component';
import { toBase64 } from '@aws-sdk/util-base64-node';
import { environment } from '@env/environment';
import { NonAccessTemplateComponent } from './non-access-template/non-access-template.component';
import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe()
@Component({
  selector: 'view-template-list',
  templateUrl: './view-template-list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ViewTemplateListComponent implements OnInit, OnDestroy {
  subscription = new Subscription();
  @Input() linked_record;
  @Input() formsList;

  @Input() currentFormId;
  @Input() currentuserId;
  @Input() hideManageButton = false;
  @Input() getLinkedLocation = false;
  @Input() linkedLocation = false;
  @Input() setZeroMargin = false;
  @Input() show_left = false;
  @Input() hideCheckbox = true;
  @Input() isRemoveEditSaveSharing = false;
  @Input() isCapitalCommitment = false;
  is_LinkedFileLoading = true;
  hideSuggestion = false;
  linkedTemplate = [];
  urlLinks = [];
  files: any = [];
  sk;
  security_key;
  @Output() manageTemplate = new EventEmitter<any>();
  @Output() locationLinkedTemplateSelectionChange = new EventEmitter<{
    template: any;
    index: number;
    isChecked: boolean;
  }>();

  selectionState: { [key: string]: boolean } = {};

  constructor(
    private _documentService: DocumentService,
    private dialog: MatDialog,
    private cd: ChangeDetectorRef,
    private cryptoService: CryptoService
  ) {}
  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
  ngOnInit(): void {
    this.getLinkedForms();
  }
  openManageTemplate() {
    if (this.hideManageButton) {
      return;
    }
    this.manageTemplate.emit(this.linked_record);
  }
  // method to get file extension
  openTemplate(file, index, fileName) {
    if (file.writeAccess && (file.origin == 'vault' || file.origin == 'location' || file.origin == 'contact' || file.origin == 'password')) {
      const dialogOpen = this.dialog.open(AddDocumentComponent, {
        disableClose: true,
        data: {
          file,
          mode: 'edit',
          isintelligent: false,
          isfileListLoad: true,
          isFromChecklist: true,
          vufid: file.vault_user_form_id,
          vault_user_form_user_id: file.userid,
          isReport: true,
        },
        panelClass: 'full-window-dialog-add-document',
        autoFocus: false,
      });
      this.subscription.add(
        dialogOpen.afterClosed().subscribe((res) => {
          this.getLinkedForms();
        })
      );
    } else if (true) {
      this.subscription.add(
        this._documentService.downloadVaultFile(this.currentuserId, file.id, null).subscribe(async (res) => {
          this.showPDFImageProcess(res, index, fileName, res.data.data);
        })
      );
    }
    if (!file.writeAccess) {
      this.dialog.open(NonAccessTemplateComponent, {
        panelClass: 'shared-doc-view-dialog',
        data: {
          template: file,
        },
      });
    }
  }
  showPDFImageProcess(res, index, fileName, filedata) {
    //set data for pdf viewer
    let file = this.linkedTemplate[index];
    file['file_name'] = file.display_file_name;
    this.dialog.open(SharedDocViewerDialogComponent, {
      width: '100%',
      height: '100%',
      panelClass: 'shared-doc-view-dialog',
      data: {
        index: index,
        file: file,
        urlLink: filedata,
      },
    });
    this.cd.markForCheck();
  }

  getLinkedForms() {
    this.is_LinkedFileLoading = true;
    let sub_type = this.linked_record.type;
    if (sub_type == 'Physical Location') {
      sub_type = 'Physical';
    } else if (sub_type == 'Password Location') {
      sub_type = 'Password';
    }
    const data = {
      user_id: this.currentuserId,
      vault_user_form_id: this.currentFormId,
      type_template_list: this.linked_record.template_list,
      type: this.linked_record.type_template,
      sub_type: sub_type,
    };
    if (this.linkedLocation) {
      this.subscription.add(
        this._documentService.getFormsLinkingSearchItemTOSetupLocation(data).subscribe(
          (res) => {
            this.linkedTemplate = res;
            this.is_LinkedFileLoading = false;
            this.cd.detectChanges();
          },
          (error) => {
            this.is_LinkedFileLoading = false;
            this.cd.detectChanges();
          }
        )
      );
    } else if (this.getLinkedLocation) {
      this.subscription.add(
        this._documentService.getFormsLinkedLocation(data).subscribe(
          (res) => {
            this.linkedTemplate = res.data;
            try {
              let status = res['setupData'].status;
              if (status == 'complete') {
                this.hideSuggestion = true;
              }
            } catch (error) {}
            this.is_LinkedFileLoading = false;
            this.cd.detectChanges();
          },
          (error) => {
            this.is_LinkedFileLoading = false;
            this.cd.detectChanges();
          }
        )
      );
    } else {
      this.subscription.add(
        this._documentService.getFormsLinked(data).subscribe(
          (res) => {
            this.linkedTemplate = res.data;
            try {
              let status = res['setupData'].status;
              if (status == 'complete') {
                this.hideSuggestion = true;
              }
            } catch (error) {}

            this.is_LinkedFileLoading = false;
            this.cd.detectChanges();
          },
          (error) => {
            this.is_LinkedFileLoading = false;
            this.cd.detectChanges();
          }
        )
      );
    }
  }
  getProgressPercentage(template) {
    if (!template.totalCommitment) return 0;
    const percentage = (1 - template.remainingBalance / template.totalCommitment) * 100;
    return Math.max(0, Math.min(100, percentage));
  }
  accessTemplate(template) {
    if (
      template.writeAccess &&
      (template.origin == 'vault' || template.origin == 'location' || template.origin == 'contact' || template.origin == 'password')
    ) {
      return true;
    }
    return false;
  }

  onLocationLinkedTemplateSelectionChange(template: any, index: number, isChecked: boolean) {
    const key = `linked_template_${index}`;
    this.selectionState[key] = isChecked;
    this.locationLinkedTemplateSelectionChange.emit({ template, index, isChecked });
    this.cd.detectChanges();
  }

  clearSelections() {
    this.selectionState = {};
    this.cd.detectChanges();
  }

  removeTemplate(template: any) {
    let vault_user_form_uploads_id = template.vault_user_form_uploads_id;
    this.subscription.add(
      this._documentService
        .deleteUserFormAssociation(
          this.currentuserId,
          this.currentFormId,
          template.linked_form_id ? template.linked_form_id : template.formid,
          vault_user_form_uploads_id
        )
        .subscribe((result) => {
          this.getLinkedForms();
          this.cd.detectChanges();
        })
    );
  }
}
